'use strict';
const angular = require('angular');

/*@ngInject*/
export function LeaderboardService($resource) {
  return $resource('/api/leaderboards/:id', {
    name: '@_id'
  },{
    getByGameAndFlavor: {
      method: 'GET',
      url: "/api/leaderboards/:game/:flavor",
      isArray: true
    }
  });
}


export default angular.module('conduuApp.LeaderboardService', [])
  .factory('LeaderboardService', LeaderboardService)
  .name;



// WEBPACK FOOTER //
// ./client/services/leaderboard/leaderboard.service.js